import { createBrowserRouter, Outlet, RouteObject } from 'react-router-dom'
import { TenantScopedLayout } from '../components/common/TenantScopedLayout'
import DashboardMainPage from '../pages/dashboard/dashboard.page'
import ProtectedRoute from './protected.route'
import {
  AddEditRecordWarpper,
  AddEditRecordWarpperCall,
} from '../pages/AddEditViewRecord.page'
import EntitiesHomepage from '../pages/EntityHome.page'
import {
  addRoute,
  callRoute,
  editRoute,
  entitiesRoute,
  tabRoute,
  view360Route,
  viewRoute,
} from './route.constant'
import TenantIdBreadcrumb from '../components/common/TenantIdBreadCrumb'
import EntityIdBreadcrumb from '../components/common/EntityIdBreadCrumb'
import QueueConfigRouter from './QueueConfig.route'
import { applicationPreferencesRoutes } from './applicationPreferences.route'
import IntakeQueue from '../pages/patient-adherence/intake-queue.page'
import PatientAdherence from '../pages/patient-adherence/patient-adherence.page'
import UserMsalErrorPage from '../pages/errors/UserMsalError.page'
import ErrorLayout from '../layouts/ErrorLayout'
import View360Record from '../pages/View360Record.page'
import { correspondenceLogsRoutes } from './correspondenceLogs.route'
import { permissionAssignmentRoutes } from './permissionAssignment.route'
import TabWrapper from '../pages/TabRecord.page'
import BenefitVerification from '../pages/Workflow/WorkflowReview.page'
import workflowRoutes from './workflow.routes'
import UserNotFoundPage from '../pages/errors/UserNotFound.page'
import { DashboardQueueTable } from '../pages/dashboard/DashboardQueueTable'
import workBasketRoutes from './workBasket.route'
import { CreateInteraction } from '../pages/call-interaction/CreateInteraction'
import InteractionListing from '../pages/InteractionListing.page'
import ReportsPage from '../pages/operational-reports/reports.page'
import LogoutPage from '../pages/Logout.page'
import { ReadOnlyProtectedRoute } from '../guards/readonly.guard'
import { TenantRootRedirect } from '../components/common/TenantRootRedirect'
import { integrationLogsRoutes } from './integrationLogs.route'

const routes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <TenantRootRedirect />,
      },
      {
        path: '*',
        element: <TenantRootRedirect />,
      },
      {
        path: ':tenantId',
        element: <TenantScopedLayout />,
        children: [
          {
            path: '',
            element: <DashboardMainPage />,
            handle: {
              crumb: () => 'Dashboard',
            },
          },
          {
            path: 'operational-reports',
            element: <ReportsPage />,
            handle: {
              crumb: () => 'Reports',
            },
          },
          {
            path: 'queue/:queueId',
            element: <DashboardQueueTable />,
          },
          {
            path: 'benefit-verification',
            element: <BenefitVerification />,
          },
          // {
          //   path: '/intake-new',
          //   element: <IntakeQueue/>
          // }

          // { ...PatientAdherenceRouter },
          { ...workBasketRoutes },
          { ...QueueConfigRouter },
          {
            path: `${entitiesRoute}`,
            element: <Outlet />,
            handle: {
              crumb: () => <TenantIdBreadcrumb left={'Entities - '} />,
            },
            children: [
              {
                path: ``,
                element: <EntitiesHomepage />,
                handle: {
                  crumb: () => 'Listing',
                },
              },
              {
                path: ':entityId',
                element: (
                  // <div>
                  <Outlet />
                  // </div>
                ),
                handle: {
                  crumb: () => <EntityIdBreadcrumb />,
                },
                children: [
                  {
                    path: '',
                    element: <EntitiesHomepage isSelected />,
                  },
                  {
                    path: addRoute,
                    element: <AddEditRecordWarpper mode="add" key={'add'} />,
                    handle: {
                      crumb: () => 'Add',
                    },
                  },
                  {
                    path: `${viewRoute}/:id`,
                    element: <AddEditRecordWarpper mode="view" key={'view'} />,
                    handle: {
                      crumb: () => 'View',
                    },
                  },
                  {
                    path: `${editRoute}/:id`,
                    element: <AddEditRecordWarpper mode="edit" key={'edit'} />,
                    handle: {
                      crumb: () => 'Edit',
                    },
                  },
                  {
                    path: `${tabRoute}/:id`,
                    element: <TabWrapper />,
                    handle: {
                      crumb: () => 'View',
                    },
                  },
                  {
                    path: `${view360Route}/:id`,
                    element: <View360Record />,
                    handle: {
                      crumb: () => '360 View',
                    },
                  },
                ],
              },
            ],
          },
          // NOTE: do not remove
          // {
          //   path: '/poc/hybrid-layout',
          //   element: <HybridLayoutWrapper />,
          // },
          {
            path: `intake-new`,
            element: <IntakeQueue />,
          },
          {
            path: 'intake-new/patient-adherence',
            element: <PatientAdherence />,
          },
          {
            path: `${callRoute}`,
            handle: {
              crumb: () => <TenantIdBreadcrumb left={'Interaction Log - '} />,
            },
            element: <Outlet />,
            children: [
              {
                path: ``,
                element: <InteractionListing />,
              },
              {
                path: 'create/:communicationId',
                handle: {
                  crumb: () => 'Create',
                },
                element: (
                  <ReadOnlyProtectedRoute>
                    <CreateInteraction />
                  </ReadOnlyProtectedRoute>
                ),
              },
              {
                path: 'edit/:communicationId',
                handle: {
                  crumb: () => 'Edit',
                },
                element: (
                  <ReadOnlyProtectedRoute>
                    <CreateInteraction />
                  </ReadOnlyProtectedRoute>
                ),
              },
              {
                path: 'create/:communicationId/case/:caseId',
                handle: {
                  crumb: () => 'Create',
                },
                element: (
                  <ReadOnlyProtectedRoute>
                    <CreateInteraction />
                  </ReadOnlyProtectedRoute>
                ),
              },
              {
                path: 'edit/:communicationId/case/:caseId',
                handle: {
                  crumb: () => 'Edit',
                },
                element: (
                  <ReadOnlyProtectedRoute>
                    <CreateInteraction />
                  </ReadOnlyProtectedRoute>
                ),
              },
              {
                path: ':entityId',
                element: <Outlet />,

                children: [
                  {
                    path: addRoute,
                    element: (
                      <AddEditRecordWarpperCall mode="add" key={'add'} />
                    ),
                    handle: {
                      crumb: () => <EntityIdBreadcrumb right={' - Add'} />,
                    },
                  },
                  {
                    path: `${viewRoute}/:id`,
                    element: (
                      <AddEditRecordWarpperCall mode="view" key={'view'} />
                    ),
                    handle: {
                      crumb: () => <EntityIdBreadcrumb right={' - View'} />,
                    },
                  },
                  {
                    path: `${editRoute}/:id`,
                    element: (
                      <AddEditRecordWarpperCall mode="edit" key={'edit'} />
                    ),
                    handle: {
                      crumb: () => <EntityIdBreadcrumb right={' - Edit'} />,
                    },
                  },
                ],
              },
            ],
          },

          //workflow
          { ...workflowRoutes },

          { ...applicationPreferencesRoutes },
          { ...permissionAssignmentRoutes },
          { ...correspondenceLogsRoutes },
          { ...integrationLogsRoutes },
        ],
      },
    ],
  },
  {
    path: '/logout',
    element: <LogoutPage />,
  },
  {
    path: '/error',
    element: <ErrorLayout />,
    children: [
      {
        path: 'user-not-found',
        element: <UserNotFoundPage />,
      },
      {
        path: 'user-error',
        element: <UserMsalErrorPage />,
      },
      {
        path: 'user-not-found',
        element: <UserNotFoundPage />,
      },
    ],
  },
]

const RootRouter = createBrowserRouter(routes)

export default RootRouter
